import { DatePipe } from "@angular/common";
import { Injectable, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { appService } from "../../../_services/app.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class OrdersService implements OnInit {
  private customerIdSource = new BehaviorSubject<number | null>(null);
  currentCustomerId = this.customerIdSource.asObservable();
  TenantId: any;
  DeliveryCrossDockList: any = [];
  UOMList: any[] = [];
  Incoterm: any = [];
  PurposeofShipment: any = [];
  Currency: any = [];
  UserList: any = [];
  private billType: boolean = false;
  private Type: boolean = false;
  data: any;

  GeneratedInvoiceList: any[] = [];
  navigationSource: string = '';
  
  constructor(
    private _appService: appService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
  }

  setCustomerId(customerId: number) {
    this.customerIdSource.next(customerId); // Update the customerId
  }

  LoadDeliveryCrossDock(TenantId: any): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetById("OrdersByVehicle", "GetDeliveryCrossDock", TenantId)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            this.DeliveryCrossDockList = response;
            resolve(response);
          },
          (err) => {
            var OwnershipError = this.translate.instant(
              "READYTODISPATCH.Erroroccurred"
            );
            this.toastr.error(OwnershipError, "error");
          }
        );
    });
  }

  LoadProductData(SerachValue: any): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetById("OrdersByVehicle", "obv_ProductList", SerachValue)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            this.DeliveryCrossDockList = response;
            resolve(response);
          },
          (err) => {
            var OwnershipError = this.translate.instant(
              "READYTODISPATCH.Erroroccurred"
            );
            this.toastr.error(OwnershipError, "error");
          }
        );
    });
  }

  GetUOMList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetById("Product", "GetUOMListNew", null).subscribe(
        (response) => {
          if (response) {
            response.map((x) => {
              x.name = x.Label;
              x.value = x.Id;
            });
          }
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  GetDriverList(value, pageNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByQueryPage("Expense", "GetDriversList", value, pageNo).subscribe(
        (response) => {
          if (response) {
            response.Results.map((x) => {
              x.name = x.text;
              x.value = x.id;
            });
          }
          resolve(response.Results);
          return response.Results;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  GetProductCategory(TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Product", "GetCategoryList", TenantId)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  //add by burhan - 24-Jan-2026
  getWarehouseCode(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "GetWarehouseCode", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getWarehouseName(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "GetWarehouseName", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getBinCumulative(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "GetBinCumulative", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getProductForBinUtilization(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "GetProductForBinUtilization", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }
  //end by burhan - 24-Jan-2026
  GetProductBusinessCategory(TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Product", "GetBusinessCategoryList", TenantId)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetCustomerSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId(
          "Sales",
          "GetCompanydata",
          SerachValue,
          PageNo,
          TenantId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetPickingStrategy(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "PickingStrategy")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetStorageType(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "GetStorageType")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  AccountTypeSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId(
          "Product",
          "GetAccountdata",
          SerachValue,
          PageNo,
          TenantId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetGSTTaxGroup(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.Get("Charge", "GetGSTGroupList").subscribe(
        (response) => {
          if (response) {
            response.map((x) => {
              x.name = x.Label;
              x.value = x.Id;
            });
          }
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  GetDimensionList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Dimension", "GetDimensionNameList", null)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ProuductSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId(
          "Product",
          "GetProductForKitdata",
          SerachValue,
          PageNo,
          TenantId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  prd_kit_GetProductList(TenantId, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByTwoId("Product", "prd_kit_GetProductList", TenantId, SerachValue).subscribe((response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  VendorSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId(
          "Tyres",
          "GetSupplierName",
          SerachValue,
          PageNo,
          TenantId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  so_po_getSupplierName(SerachValue, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByTwoId("so_GoodsOutward", "so_po_getSupplierName", SerachValue, TenantId).subscribe((response) => {
        if (response) {
          response.map((x) => {
            x.name = x.text;
            x.value = x.id;
          });
        }
        resolve(response);
        return response;
      },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  getOwnershiptypeWoHired(SearchValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("Common", "getOwnershiptypeWoHired", SearchValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getPoOrderNo(type: string, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId("so_GoodsOutward", "get_POOrderList", type, SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getSoInwardOrderNo(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "get_SoInwardOrderList", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  get_So_MovementOrderList(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "get_So_MovementOrderList", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  get_LocationCode(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "get_LocationCode", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetAirShipOrderNo(CompanyId, TenentId, UserId, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFourId("so_GoodsOutward", "GetAirShipOrderNo", CompanyId, TenentId, UserId, SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetAirShipConsignee(CompanyId, TenentId, UserId, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFourId("so_GoodsOutward", "GetAirShipConsignee", CompanyId, TenentId, UserId, SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getEANCode(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "getEANCode", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getCustSupplierList(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "getCustSupplier", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  AllTransporter(TenantId, SearchValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByTwoId("Booking", "GetAllTransport", TenantId, SearchValue).subscribe((response) => {
        resolve(response);
        return response;
      },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        });
    });
  }

  ol_getOrderCustomerList(CompanyId, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByTwoId("Order_LTL", "ol_getOrderCustomerList", CompanyId, SerachValue).subscribe((response) => {
        resolve(response);
        return response;
      },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  ShipperConsigneeSelect1(customerId, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId(
          "so_GoodsOutward",
          "obv_ShipToPartyList",
          customerId,
          SerachValue
        )
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ShipperConsigneeSelect2(SerachValue, Id, userId, companyId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFourId(
          "so_GoodsOutward",
          "po_ShipToPartyList",
          userId,
          Id,
          SerachValue,
          companyId
        )
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetCurrencyList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "Currency")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ProuductListSelect2(
    SearchValue,
    CompanyId,
    CustomerID,
    Taxtype,
    Taxable
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFiveId(
          "OrdersByVehicle",
          "obv_ProductList",
          CompanyId,
          CustomerID,
          Taxtype,
          Taxable,
          SearchValue
        )
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetIncoTerms(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "IncoTerms")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetPurchaseOrderType(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "po_PurchaseOrderType")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Label;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  VehicleNoSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("Expense", "GetVehicleList", SerachValue, PageNo)
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  TransporterSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage(
          "OperationalReport",
          "GetTransporterAdvanceReport",
          SerachValue,
          PageNo
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
                x.TransporterType = x.TransporterType;  //added by fahim 25-12-2025
                x.ShortCode = x.ShortCode;  //added by fahim 28-03-2026
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetBankName(query, page, CompanyId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageCompanyId(
          "BankReconcile",
          "GetAccountListForBankReconcile",
          query,
          page,
          CompanyId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetIncoterms(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "IncoTerms")
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            this.Incoterm = response;
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  CustomerSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId(
          "Tyres",
          "GetCustomerList",
          SerachValue,
          PageNo,
          TenantId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ProuductSelect2V2(SerachValue, UserId, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      var obj: any = {};
      obj.SearchValue = SerachValue;
      obj.TenantId = TenantId;
      obj.isCustomer = false;
      obj.useerId = UserId;
      obj.Start = 0;
      obj.PerPage = 1000;

      this._appService.Post("Product", "ProductGetListNew", obj).subscribe(
        (response) => {
          if (response) {
            response.map((x) => {
              x.name = x.ProductName;
              x.value = x.Id;
            });
          }
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  GetShipmetpurpose(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "PurposeofShipment")
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            this.PurposeofShipment = response;
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  CustomerSelect2V2(SerachValue, UserId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId("OrdersByVehicle", "obv_CustomerList", UserId, SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetCharge(PageNo, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoParam("Charge", "GetSelect2AllChargeNew", SerachValue, PageNo)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetDeliveryCrossDockList(TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("OrdersByVehicle", "GetDeliveryCrossDock", TenantId)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetReasonSelect2(SerachValue, PageNo, ReasonFor): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByCustom(
          "ReasonMaster",
          "GetSelect2ReasonList",
          SerachValue,
          PageNo,
          "ReasonFor",
          ReasonFor
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetLocationSelect2(SerachValue, PageNo, Type, CustomerId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByType(
          "OrdersByVehicle",
          "GetLocationCode",
          SerachValue,
          PageNo,
          Type,
          CustomerId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetLocationWithIdSelect2(SerachValue, PageNo, Type, CustomerId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByType(
          "OrdersByVehicle",
          "GetLocationCodeWithId",
          SerachValue,
          PageNo,
          Type,
          CustomerId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  PickupBranchSelect2(SerachValue, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId("OrdersByVehicle", "GetPickupBranch", TenantId, SerachValue)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ConsigneeSelect2(
    SerachValue,
    PageNo,
    CustomerId,
    DeliveryLocationCode
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryByLocationCode(
          "OrdersByVehicle",
          "obv_GetConsineeName",
          SerachValue,
          CustomerId,
          DeliveryLocationCode
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ShipperSelect2(
    SerachValue,
    PageNo,
    CustomerId,
    DeliveryLocationCode
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryByLocationCode(
          "OrdersByVehicle",
          "obv_GetShipperName",
          SerachValue,
          CustomerId,
          DeliveryLocationCode
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getCountryDetailByPostcode(param, category, parentId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageCategoryNameParentId(
          "Company",
          "GetCountryWiseListData",
          param,
          1,
          category,
          parentId
        )
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  getVehicleType(param, page, NetworkId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageByCustom(
          "VehicleMaster",
          "GetSelect2VehicleList",
          param,
          1,
          "NetworkId",
          NetworkId
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  getProductSelect2(param, page, CustomerID): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageByCustom(
          "OrdersByVehicle",
          "GetProductForOrderdata",
          param,
          1,
          "CustomerID",
          CustomerID
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetUnitList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "UOMProduct")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetTransportServiceList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .Get("OrdersByVehicle", "GetTransportServiceList")
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  Getobv_GetShipperName(
    SerachValue,
    PageNo,
    Customer,
    LocationCode
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFourId(
          "Tyres",
          "Getobv_GetShipperNamet",
          SerachValue,
          PageNo,
          Customer,
          LocationCode
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetLocaitonCodeNew(SerachValue, PageNo, Customer, Type): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFourId(
          "Tyres",
          "GetLocaitonCodeNew",
          SerachValue,
          PageNo,
          Type,
          Customer
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ReasonSelect2(SerachValue, PageNo, ReasonFor): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByThreeId(
          "ReasonMaster",
          "GetSelect2ReasonListNew",
          SerachValue,
          PageNo,
          ReasonFor
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetCurency(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "Currency")
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            this.Currency = response;
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  Getobv_GetConsineeName(
    SerachValue,
    PageNo,
    Customer,
    LocationCode
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFourId(
          "Tyres",
          "Getobv_GetConsineeName",
          SerachValue,
          PageNo,
          Customer,
          LocationCode
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetVehicleTypeselect2(param, page): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPage(
          "ManualvehiclePlanning",
          "GetSelect2VehicleData",
          param,
          page
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetBookingVehicleNoSelect2(
    param,
    page,
    TransporterId,
    VehicleTypeId
  ): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageVehicleNo(
          "Booking",
          "VehicleListSelect2",
          param,
          page,
          TransporterId,
          VehicleTypeId
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetDriverSelect2(param, page, TransporterId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageByCustom(
          "Booking",
          "GetDriverList",
          param,
          page,
          "TransporterId",
          TransporterId
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  DriverListSelect2(param, page, TransporterId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageByCustom(
          "Booking",
          "DriverListSelect2",
          param,
          page,
          "TransporterId",
          TransporterId
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  po_rtn_VendorSelect2(userId, SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId(
          "so_GoodsOutward",
          "po_rtn_GetSupplierName",
          userId,
          SerachValue
        )
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetCustomerLisNewV2t(SerachValue, PageNo, TenantId, Type): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantByTwoId(
          "Tyres",
          "GetCustomerLisNewV2t",
          SerachValue,
          PageNo,
          TenantId,
          Type
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getCountryByRateContract(param, customerId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageCountry(
          "Company",
          "GetCountryByRateContract",
          param,
          1,
          customerId
        )
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetCessTaxGroup(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.Get("Charge", "GetCessGroupList").subscribe((response) => {
        if (response) {
          response.map(x => {
            x.name = x.Label;
            x.value = x.Id;
          })
        }
        resolve(response);
        return response;
      },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    })
  }

  //DropDown For User
  GetUserName(SerachValue, page): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("AccountingReport", "NewGetUserDropDown", SerachValue, page)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.value;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  NewGetDriver(SerachValue, page, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId("OperationalReport", "NewGetDriverList", SerachValue, page, TenantId)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.value;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetReferenceNoList(SerachValue, page): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("OperationalReport", "GetReferenceNoSelect2", SerachValue, page)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.id;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  //For Account Name
  NewAccountNameList(SerachValue, page): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("AccountingReport", "NewGetAccountName", SerachValue, page)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.value;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  NewChargeCodeList(SerachValue, page): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("AccountingReport", "NewGetChargeCode", SerachValue, page)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.value;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetProjectCodeList(SerachValue, pageNo, selectedCustomerId): Promise<any> {
    return new Promise((resolve, reject) => {
      //changed from 'GetByQueryPageByTenantId' => 'GetByQueryPageBySelectedCustomerId' by BURHAN - 13-April-2026
      this._appService.GetByQueryPageBySelectedCustomerId("OrdersByVehicle", "GetProjectCodeList",
        SerachValue, pageNo, selectedCustomerId).subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.ProductName;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetTripData(SerachValue, pageNo, companyId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByThreeId("OperationalReport", "GettripIncomeExpense_getTripNo",
        SerachValue, pageNo, companyId).subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetTransactionData(SerachValue, companyid): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByTwoId("Sales", "GetTransactionTo",
        companyid, SerachValue).subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetTransporterData(SerachValue, companyid): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByTwoId("AccountingReport", "GetTransporterData",
        companyid, SerachValue).subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetCustomerData(SerachValue, companyid): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByTwoId("AccountingReport", "GetCustomerData",
        companyid, SerachValue).subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetCompanyCode(SerachValue, pageNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByQueryPage("OperationalReport", "NewGetCompanyCode",
        SerachValue, pageNo).subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  NewGetInvoiceNo(SerachValue, pageNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByQueryPage("OperationalReport", "NewGetInvoiceNo",
        SerachValue, pageNo).subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  NewGetStorageTypes(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.Get("Product", "NewGetStorageTypes",
      ).subscribe(
        (response) => {
          if (response) {
            response.map((x) => {
              x.name = x.text;
              x.value = x.id;
            });
          }
          resolve(response);
          return response;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  //Get Brand Name Dropdown
  GetBrandName(SerachValue, page): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("AccountingReport", "GetBrandName", SerachValue, page)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.text;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  //Drop for City,State,Country (from Carrier.Carriertranshipmentpoints)
  GetCountryStateTown(SerachValue, type): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoParam("OperationalReport", "GetCountryStateTown", SerachValue, type)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.text;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  //Get Dropdown for warehouse ownership 
  GetWarehouseOwners(SerachValue, page): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("AccountingReport", "GetWarehouseOwners", SerachValue, page)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.text;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getNewDocumentTypes(SerachValue,): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQuery("AccountingReport", "getNewDocumentTypes", SerachValue)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.value;
                x.value = x.value;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }


  // Warehouse List Dropdown(Carrirer.Carriertranshipmentpoints)
  getCTPWarehouseList(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("so_GoodsOutward", "getCTPWarehouseList", SerachValue)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  // Dropdown for Account Year
  GetAccountingYear(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .Get("Common", "GetAccountingYear")
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  // Dropdown For InvoiceList  
  GetInvoiceListByCompany(value, searchvalue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId("Sales", "GetInvoiceListByCompany", value, searchvalue)
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  // Dropdown For Invoice TripNo 
  GetTripNoListByCompany(value, searchvalue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId("Sales", "GetTripNoListByCompany", value, searchvalue)
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  // Dropdown for ChargeType
  GetChargeType(TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Charge", "GetChargeType", TenantId)
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.ChargeType;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  // Dropdown For Receipt No  for sales
  GetReceiptNoByCompany(Id, searchvalue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId("Sales", "GetReceiptNoByCompany", Id, searchvalue)
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  // Dropdown For Account list sales
  GetAccountByCompany(Id, searchvalue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId("Expense", "GetPaidThrough", Id, searchvalue)
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  //Dropdown for PaymentMode
  GetPaymentModes(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "PaymentMode")
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response = response
                .map((x) => ({
                  name: x.Label,
                  value: x.Id,
                }))
                .filter((ele) => ele.name !== "Debtors or Customers");
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  SalesCustomerSelect2(SerachValue, PageNo, TenantId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId(
          "Sales",
          "GetCustomerList",
          SerachValue,
          PageNo,
          TenantId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  //Dropdown For Expense No 
  ExpenseNoDropdown(CompanyId, SearchValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoId(
          "Expense",
          "GetRcptExpenseNoByCompany",
          CompanyId,
          SearchValue,
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }


  // Dropdown For Expense Account
  GetExpenseAccount(SerachValue, PageNo,): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage(
          "Expense",
          "GetIncomeAccount",
          SerachValue,
          PageNo,
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }


  // Dropdown For Expense Account
  GetExpenseAccountForExpense(SerachValue, PageNo,): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage(
          "Expense",
          "GetExpenseAccount",
          SerachValue,
          PageNo,
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
                x.IntraStateId = x.IntraStateId;
                x.OutsideStateId = x.OutsideStateId;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetTyreList(SerachValue, PageNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("Expense", "GetTyreList", SerachValue, PageNo)
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetSelect2ConsignmentList(Obj): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .Post("Sales", "GetSelect2ConsignmentList", Obj)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            console.log("response from GetSelect2ConsignmentList:", response);
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  // vehicle list Dropdown For container movement
  VehicleListForContainerMovement(param, Companyid): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByTwoParam(
          "Vahicle",
          "VehicleListForContainerMovement",
          param,
          Companyid
        )
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  getOriginDestinationForFTL(param, param2): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByTwoParam(
          "OrdersByVehicle",
          "getOriginDestinationForFTL",
          param,
          param2
        )
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  //added by vithu 26-03-2025
  ChargesSelect2(SerachValue, PageNo, ChargeType, GSTType, TransporterId, THCId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetQueryPagecharge(
          "Bills",
          "GetChargeForAccouting",
          SerachValue,
          PageNo,
          ChargeType,
          GSTType,
          TransporterId,
          THCId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  ChargesSelect2Recordincome(SerachValue, PageNo, TenantId, CompanyId, CustomerId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetQueryPagechargeRIncome(
          "byVehicleIncome",
          "GetChargeListForOrdersByVehicle",
          SerachValue,
          PageNo,
          TenantId,
          CompanyId,
          CustomerId)
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetSelectOrderVehicleList(param, page, OrderId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageByCustom(
          "VehicleMaster",
          "GetSelectOrderVehicleList",
          param,
          1,
          "OrderId",
          OrderId
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetwarehouseListNew(SearchValue, CompanyId, UserId): Promise<any> {
    return new Promise((resolve) => {
      var obj: any = {};
      obj.SearchValue = SearchValue;
      obj.CompanyId = CompanyId;
      obj.UserId = UserId;

      this._appService
        .Post(
          "Carrier",
          "GetwarehouseListNew",
          obj
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetLocationType(SearchValue, WarehouseId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByTwoId(
          "Carrier",
          "GetLocationType",
          SearchValue,
          WarehouseId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetLocation(SearchValue, WarehouseId, LocationTypeId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByThreeId(
          "Carrier",
          "GetLocation",
          SearchValue,
          WarehouseId,
          LocationTypeId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetInwardNoSelect2(SearchValue, CompanyId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByTwoId(
          "Carrier",
          "GetInwardNoSelect2",
          SearchValue,
          CompanyId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetProductSelect2(SearchValue, CustomerId, Type): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByThreeId(
          "Carrier",
          "GetProductSelect2",
          SearchValue,
          CustomerId,
          Type
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetLabelSelect2(SearchValue): Promise<any> {
    return new Promise((resolve) => {
      var obj: any = {};
      obj.SearchValue = SearchValue;
      this._appService
        .Post(
          "Carrier",
          "GetLabelSelect2",
          obj
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  getBillType(): boolean | null {
    return this.billType;
  }

  setBillType(billType: boolean) {
    this.billType = billType;
  }

  getType(): boolean | null {
    return this.Type;
  }

  setType(Type: boolean) {
    this.Type = Type;
  }

  setData(data: any) {
    this.data = data;
  }

  getData() {
    return this.data;
  }

  clear() { this.data = null; }

  GetTyreAccountExpense(SearchValue, page, TenantId): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageByTenantId(
          "Tyres",
          "GetAccountTypeExpense",
          SearchValue, page, TenantId
        ).subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  //added by vithu 13-05-2025
  GetRetreadingStatus(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("Common", "GetLookByCategoryName", "TyresMasterPosition")
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  GetTyreNo(param, page): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPage(
          "Tyres",
          "TyreNoForTyreAssiged",
          param,
          page
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetUnassignTyreConditionDataList(UserId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetById("TyreAssgin", "ta_GetUnassignTyreConditionDataList", UserId)
        .subscribe(
          (response) => {
            console.log(response);
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Driver type !",
              "error"
            );
            reject(err);
          }
        );
    });
  }

  getIssueCategory(): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .Get(
          "Issue",
          "GetIssueCategoryName",
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.CategoryName;
                x.value = x.CategoryName;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  IssueNoSelect2(SerachValue,): Promise<any> {
    return new Promise((resolve, reject) => {
      var obj: any = {};
      obj.SearchValue = SerachValue;
      this._appService
        .Post("Issue", "IssueNoSelect2", obj)
        .subscribe(
          (response) => {
            if (response) {
              response.map(x => {
                x.name = x.text;
                x.value = x.id;
              })
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  // dropdown for Reminder page mobile no
  GetPhoneNumberList(value, pageNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByQueryPage("Reminder", "GetPhoneNumberList", value, pageNo).subscribe(
        (response) => {
          if (response) {
            response.Results.map((x) => {
              x.name = x.text;
              x.value = x.id;
            });
          }
          resolve(response.Results);
          return response.Results;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  GetEmailList(value, pageNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByQueryPage("Reminder", "GetEmailList", value, pageNo).subscribe(
        (response) => {
          if (response) {
            response.Results.map((x) => {
              x.name = x.text;
              x.value = x.id;
            });
          }
          resolve(response.Results);
          return response.Results;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  GetReminderVehicleList(value, pageNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByQueryPage("Reminder", "GetVehicleList", value, pageNo).subscribe(
        (response) => {
          if (response) {
            response.Results.map((x) => {
              x.name = x.text;
              x.value = x.id;
            });
          }
          resolve(response.Results);
          return response.Results;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }
  //end

  // DropDown For ConsignmentWise List response value is ConsignmentDetails 'Id' name is FCNumber-UniqueChar
  ConsignmentWiseList(QueryVal, Type, OrderNo, BookingId): Promise<any> {
    return new Promise((resolve) => {
      this._appService.GetByFourId("byVehicleIncome", "Get_NewConsignmentWiseList", QueryVal, Type, OrderNo, BookingId).subscribe((response) => {
        resolve(response);
        return response;
      },
        (err) => {
          this.toastr.error("Error occurred while fetching data!", "error");
        }
      );
    });
  }

   GetTransporterForBidding(param): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByOneParam(
          "OrdersByVehicle",
          "GetTransporterForBidding",
          param
        )
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  //added by vithu 21-08-2025 - Siddarth
  GetTrackingStatus(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      var obj: any = {};
      obj.SearchValue = SerachValue;
      this._appService
        .Post(
          "OrdersByVehicle",
          "GetTrackingStatus",
          obj
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }


  NewGetUnitList(value,CompanyId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoParam("Common", "GetUOMProduct",value,CompanyId)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.Label;
                x.value = x.Id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  //DropDown Of SalesOrder No and ID where isOrderConfirm = 1 (added by fahim 16-10-2025)
  Get_SoOrderList(SerachValue,CompanyId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoParam("OrdersByVehicle", "Get_SoOrderList", SerachValue,CompanyId)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

    // Added by priya - 28/10/2025
  GetConfirmedSoNo(SerachValue, CompanyId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService.GetByTwoParam("OrdersByVehicle", "GetConfirmedSoNo", SerachValue, CompanyId).subscribe((response) => {
        resolve(response);
        return response;
      },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
          reject(err);
        }
      );
    });
  }

  //added by fahim 25-12-2025
  GetAssignVehicleVehicleDriverList(
    param,
    page,
    CompanyId,
    TransporterId,
    VehicleId
  ): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPageAssignVehicle(
          "Booking",
          "GetVehicleDriverList",
          param,
          page,
          CompanyId,
          TransporterId,
          VehicleId
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  //added by fahim (29-12-2025)
  getFilterValueOfOriginDestination(param, param1,param2): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByThreeId(
          "OrdersByVehicle",
          "getFilterValueOfOriginDestination",
          param,
          param1,
          param2,
        )
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  GetNewUnitsList(val): Promise<any> {
    return new Promise((resolve) => {
      this._appService.GetByQuery('OrdersByVehicle','GetNewUnitsList',val).subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }
  
  //added by fahim 03-02-2026
  GetOrderForAddIntoTrip(SerachValue, BookingId, CompanyId,CustomerId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByFourId(
          "OrdersByVehicle",
          "NewGetOrderForAddIntoTrip",
          SerachValue,
          BookingId,
          CompanyId,
          CustomerId
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
                x.ReferenceNo = x.ReferenceNo;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  //added by burhan - 5-Feb-2026
  getEchallanNoData(SearchValue, CompanyId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoParam("EChallan", "getEChallanNoData", SearchValue,CompanyId)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  getEchallanOwnerNameData(SearchValue, CompanyId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoParam("EChallan", "getEChallanOwnerNameData", SearchValue, CompanyId)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  // getEchallanStatusData(SearchValue, CompanyId): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     this._appService
  //       .GetByTwoParam("EChallan", "getEChallanStatusData", SearchValue, CompanyId)
  //       .subscribe(
  //         (response) => {
  //           resolve(response);
  //           return response;
  //         },
  //         (err) => {
  //           this.toastr.error("Error occurred while fetching data !", "error");
  //           reject(err);
  //         }
  //       );
  //   });
  // }
  //ended by burhan - 5-Feb-2026

  //added by fahim 04-02-2026 :)
  GetVehicleTypeSelect2(SerachValue): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("VehicleMaster", "GetVehicleTypeSelect2", SerachValue)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetSelect2TransportServiceData(param, page): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPage(
          "ManualvehiclePlanning",
          "GetSelect2TransportServiceData",
          param,
          page
        )
        .subscribe(
          (response) => {
            if (response.Results) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  NewGetFromTocity(SerachValue,page, Type): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByThreeId("ManualvehiclePlanning", "NewGetFromTocity",SerachValue,page,Type)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  NewGetOriginDestination(SerachValue,param): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByIdparam("TyreAssgin", "GetOriginDestination",SerachValue,param)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  NewVehicleNoSelect2(SerachValue, PageNo): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPage("TyreAssgin", "GetVehicleNo", SerachValue, PageNo)
        .subscribe(
          (response) => {
            if (response) {
              response.Results.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response.Results);
            return response.Results;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  GetDriverListFromOpRept(SerachValue,Page,TenantId): Promise<any> {  //(GetDriverList From OperationalReport controller )
    return new Promise((resolve, reject) => {
      this._appService
        .GetByQueryPageByTenantId("OperationalReport", "GetDriverList",SerachValue,Page,TenantId)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }

  //END added by fahim 04-02-2026 :)

  GetUploadedBatchNo(param, page): Promise<any> {
    return new Promise((resolve) => {
      this._appService
        .GetByQueryPage(
          "ManualvehiclePlanning",
          "GetUploadedBatchNo",
          param,
          page
        )
        .subscribe(
          (response) => {
            if (response) {
              response.map((x) => {
                x.name = x.text;
                x.value = x.id;
              });
            }
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }

  getJournalEntryAccountFilter(val): Promise<any> {
    return new Promise((resolve) => {
      this._appService.GetByQuery('JournalEntry','getJournalEntryAccountFilter',val).subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
    });
  }
  //added by BURHAN - 21-April-2026
  getVehicleNumberData(SearchValue, CompanyId): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByTwoParam("EChallan", "getVehicleNumberData", SearchValue, CompanyId)
        .subscribe(
          (response) => {
            resolve(response);
            return response;
          },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
            reject(err);
          }
        );
    });
  }
  //added by BURHAN - 4-May-2026
  // Added by BURHAN - 04-05-2026
  GetTripStatusSelect2(SerachValue: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this._appService
        .GetByOneParam("VehicleMaster", "GetTripStatusSelect2", SerachValue)
        .subscribe(
          (response) => {
            if (response) {
              response.map((x: any) => {
                x.name = x.text;
                x.value = x.id;        // Both are Name (string)
              });
            }
            resolve(response || []);
          },
          (err) => {
            this.toastr.error("Error occurred while fetching Trip Status!", "error");
            reject(err);
          }
        );
    });
  }
  //end by BURHAN
}
